<template>
  <section class="faq__section__container" v-if="options['Faq']">
    <div class="wrapper__texts">
      <div class="low__text" data-animate="slideUp">{{ options['Faq']['Faq mini title']}}</div>
      <div class="text" data-animate="slideUp">{{ options['Faq']['Faq title']}}</div>
      <div class="link" @click="this.$scrollTo('footer');">
        Contact Us
        <svg width="15.000000" height="10.000000" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Union" d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
        </svg>
      </div>
    </div>
    <div class="faq__lists">
      <div
        v-for="(faq, index) in options['Faq']['Content']"
        :key="index"
        class="faq__item"
        data-animate="slideUp"
      >
        <div class="flex__wrapper" @click="toggleFaq(index)">
          <div class="text">{{ faq.text }}</div>
          <div class="opener__status">
            <svg v-if="isOpen(index)" width="32.000000" height="32.000000" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <clipPath id="clip189_8663">
                  <rect id="Icons" rx="0.000000" width="31.000000" height="31.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                </clipPath>
              </defs>
              <rect id="Icons" rx="0.000000" width="31.000000" height="31.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
              <g clip-path="url(#clip189_8663)">
                <path id="Vector (Stroke)" d="M25.66 17L7 17L7 15L25.66 15L25.66 17Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
              </g>
            </svg>
            <svg v-else width="32.000000" height="32.000000" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <clipPath id="clip189_8667">
                  <rect id="Icons" rx="0.000000" width="31.000000" height="31.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                </clipPath>
              </defs>
              <rect id="Icons" rx="0.000000" width="31.000000" height="31.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
              <g clip-path="url(#clip189_8667)">
                <path id="Union" d="M15.02 17L15.01 25.33L17.01 25.33L17.02 17L25.33 17L25.33 15L17.02 15L17.04 6.66L15.04 6.66L15.02 15L6.66 15L6.66 17L15.02 17Z" fill="#050505" fill-opacity="1.000000" fill-rule="evenodd"/>
              </g>
            </svg>
          </div>
        </div>
      <div class="desc" :id="'faq-item-' + index">
          {{ faq.description }}
      </div>
      </div>
    </div>
  </section>
</template>


<script>
import { applySlideToggle } from '@/assets/directives/slideToggle';
export default {
data() {
  return {
    openedIndexes: [], // Массив для хранения индексов открытых элементов
  };
},
  methods: {
      toggleFaq(index) {
          const idx = this.openedIndexes.indexOf(index);
          if (idx > -1) {
              this.openedIndexes.splice(idx, 1);
          } else {
              this.openedIndexes.push(index);
          }
          // Передаем строку с селектором элемента по его id
          applySlideToggle(`#faq-item-${index}`, 500); // Теперь передается строка с id
          },
  isOpen(index) {
      return this.openedIndexes.includes(index);
  }
  },

computed: {
    options() {
        return this.$store.state.options;
    },
}
};
</script>

<style scoped>
.flex__wrapper{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.faq__item{
  padding-top: 32px;
  padding-bottom: 39px;
  border-top: 1px solid rgb(222, 230, 234);
  cursor: pointer;
}
.faq__item .text{
  color: rgb(5, 5, 5);
  font-size: 32px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}

.faq__item .desc{
  color: rgb(85, 98, 114);
  font-size: 20px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  max-width: 880px;
  padding-top: 23px;
  padding-bottom: 13px;
  display: none;
}
.wrapper__texts{
  position: relative;
  margin-bottom: 36px;
}
.wrapper__texts .low__text{
  color: rgb(85, 98, 114);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  padding-bottom: 10px;
}
.wrapper__texts .text{
/* Header/H1: 44px Medium */
  color: rgb(5, 5, 5);
  font-size: 44px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  max-width: 555px;
}
.wrapper__texts .link{
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}

@media (max-width: 1024px) {
  .wrapper__texts .link{
      bottom: unset;
      top: 0;
  }
  .wrapper__texts .text{
      font-size: 32px;
      max-width: 100%;
  }
  .faq__item .text{
    font-size: 24px;
  }
  .faq__item{
    padding: 24px 0;
  }
}
@media (max-width: 768px) {
  .wrapper__texts .text{
      font-size: 22px;
  }
  .wrapper__texts .low__text{
    padding-bottom: 18px;
  }
  .faq__item .text{
    font-size: 18px;
  }
  .faq__item .desc{
    font-size: 14px;
  }
  .faq__item{
    padding: 24px 0;
  }
}
</style>